import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { SolidButton } from '@noths/polaris-client-ribbons-design-system';

import { addMembershipItemToBasket } from 'src/redux/basket/thunks';
import * as styles from './MembershipUpsell.styles';

const termsAndConditionsUrl =
  'https://www.notonthehighstreet.com/campaign/terms-and-conditions/membership';

export const MembershipUpsell = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await dispatch(addMembershipItemToBasket());
    } catch (error) {
      // TODO: allow re-try?
      setLoading(true);
    }
  };

  return (
    <div css={styles.root}>
      <h3>Get 10% off everything</h3>
      <p>10% off all year round and a host of other treats – for only £10 a year.</p>
      <SolidButton compact disabled={loading} loading={loading} onClick={handleClick} type="button">
        Join NOTHS & More
      </SolidButton>
      <hr />
      <small>
        Membership is for the purchaser only. By joining NOTHS & More, you agree to the{' '}
        <a href={termsAndConditionsUrl}>T&Cs</a> and to receive exclusive offers and content. You
        can unsubscribe anytime.
      </small>
    </div>
  );
};
